export default __webpack_public_path__ + "alberta-nursinghome.b363868f19e251e73cce.svg";